import { t1aAdmin } from "./adminOptions"

export interface NavBarRoute {
    text: string,
    routeId: string,
}
export const reportingTab: NavBarRoute[] = [
    { text: 'Overview', routeId: '/kooverview' },
    { text: 'Report', routeId: '/koreports' },
    { text: 'UpRecycle', routeId: '/uprecycleview' },
]
export const collectionTab: NavBarRoute[] = [    
    { text: 'New', routeId: '/newcollection' },
    { text: 'Status', routeId: '/collectionstatus' },
]
export const profileTab: NavBarRoute[] = [
    { text: 'Password', routeId: '/password' },
]
export const AdminCollectionTab: NavBarRoute[] = [
    { text: 'Status', routeId: '/admincollection' },
]
export const adminMenu: NavBarRoute[] = [
    { text: 'Partners', routeId: '/newadminuserpanel' },
    { text: 'Password', routeId: '/password' },
]

export const adminUserRolesMenu: NavBarRoute[] = [
    { text: t1aAdmin, routeId: '/' },
    { text: 'Partner Super Admin', routeId: '/' },
    { text: 'Partner Admin', routeId: '/' },
    { text: 'Reseller Admin', routeId: '/' },
    { text: 'Customer Admin', routeId: '/' },
    { text: 'Reseller Customer', routeId: '/' },
    { text: 'Customer', routeId: '/' },
]

